<template>
  <span
    class="pay-range-subscription-bar"
    :class="`pay-range-subscription-bar--${normalizedState}`"
    role="img"
    :aria-label="accessibleLabel"
  >
    <span class="pay-range-subscription-bar__label">{{ label }}</span>
  </span>
</template>

<script setup>
import { computed } from "vue";
import {
  formatSubscriptionBarAriaLabel,
  formatSubscriptionBarLabel,
  normalizeSubscriptionBarState,
} from "./payRangeSubscriptionBarUtils";

const props = defineProps({
  state: {
    type: String,
    default: "lapsed",
  },
  subscriptionCode: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: "",
  },
});

const normalizedState = computed(() => normalizeSubscriptionBarState(props.state));

const label = computed(() => formatSubscriptionBarLabel(props.subscriptionCode, props.title));

const accessibleLabel = computed(() =>
  formatSubscriptionBarAriaLabel(normalizedState.value, props.subscriptionCode, props.title)
);
</script>

<style scoped>
.pay-range-subscription-bar {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  height: 36px;
  padding: 11px 10px 10px;
  margin: 0;
  overflow: hidden;
  border-radius: 6px;
  border-style: solid;
}

.pay-range-subscription-bar__label {
  flex: 1 1 0;
  min-width: 0;
  margin: 0;
  overflow: hidden;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  line-height: normal;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pay-range-subscription-bar--lapsed {
  background: #e3e7ec;
  border-width: 1.5px;
  border-color: #9ea4b0;
  color: #4a5463;
}

.pay-range-subscription-bar--current {
  background: #e8fbf0;
  border-width: 1.5px;
  border-color: #027a48;
  color: #027a48;
}

.pay-range-subscription-bar--future {
  background: #f0f9ff;
  border-width: 1px;
  border-color: #eaecf0;
  color: #101828;
}
</style>
